import React from "react";
import { motion } from "framer-motion";
import { Wifi, Cloud, Brain, AlertTriangle } from "lucide-react";

const steps = [
  { step: "01", title: "Sensor Deployment", description: "Deploy IoT sensors on patients for continuous monitoring of vital signs.", icon: Wifi },
  { step: "02", title: "Data Collection", description: "Sensors collect real-time data and transmit securely to the cloud platform.", icon: Cloud },
  { step: "03", title: "AI Analysis", description: "Advanced AI algorithms analyze patterns and detect anomalies in real-time.", icon: Brain },
  { step: "04", title: "Alert & Response", description: "Instant alerts sent to healthcare providers for immediate intervention.", icon: AlertTriangle }
];

const HowItWorksSection = () => {
  return (
    <section id="how-it-works" className="how-section">
      <div className="container">
        <motion.div className="md-section-header"
          initial={{ opacity: 0, y: 20 }} whileInView={{ opacity: 1, y: 0 }} viewport={{ once: true }}
        >
          <h2>How It Works</h2>
          <p>Our streamlined process ensures seamless healthcare monitoring from sensor to response</p>
        </motion.div>

        <div className="how-grid">
          {steps.map((s, idx) => {
            const Icon = s.icon;
            return (
              <motion.div key={s.step} className="how-card"
                initial={{ opacity: 0, y: 20 }} whileInView={{ opacity: 1, y: 0 }} viewport={{ once: true }}
                transition={{ delay: idx * 0.12 }}
              >
                <div className="how-icon">
                  <Icon />
                  <div className="how-step">{s.step}</div>
                </div>
                <h3>{s.title}</h3>
                <p>{s.description}</p>
              </motion.div>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default HowItWorksSection;
